interface DropdownOptions<T> {
  label: string
  value: T
}

export const handlePrefilledDropdown = <T extends unknown>(
  options: DropdownOptions<T>[],
  preFilledValue: T | undefined | null,
) => {
  const preFilled = options.find(({ value }) => value === preFilledValue)
  return preFilled?.label || ''
}
